var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPollsBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1003,
    height: 1004,
    viewBox: "0 0 1003 1004",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.284 732.691C461.555 715.89 431.968 718.232 415.2 737.922C398.431 757.612 400.832 787.194 420.561 803.995C440.29 820.796 469.877 818.455 486.645 798.765C503.413 779.075 501.013 749.492 481.284 732.691Z",
    stroke: "#C4C4C4",
    strokeWidth: 14.9247
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.914 729.535C543.511 759.378 540.051 796.175 517.256 822.941C486.521 859.032 432.434 863.313 396.272 832.517C362.198 803.499 356.31 753.632 381.648 717.866",
    stroke: "#C4C4C4",
    strokeWidth: 5.74026
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.862 741.696C576.052 777.059 567.936 815.759 542.62 845.487C500.02 895.509 424.989 901.448 374.867 858.764C330.352 820.854 320.572 757.074 348.955 708.381",
    stroke: "#C4C4C4",
    strokeWidth: 6.88832
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.243 379.884C466.441 378.255 467.843 376.61 469.151 375.074C539.87 292.032 664.514 282.166 747.721 353.025C830.927 423.884 841.039 548.509 770.32 631.551C699.601 714.593 574.956 724.459 491.749 653.6C471.415 636.283 455.417 615.656 443.886 593.345",
    stroke: "#C4C4C4",
    strokeWidth: 6.88832
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.909 389.145C654.168 334.864 558.58 342.43 504.406 406.044C450.232 469.658 457.986 565.231 521.726 619.513C585.466 673.794 681.055 666.228 735.229 602.614C789.403 539 781.649 443.427 717.909 389.145Z",
    stroke: "#C4C4C4",
    strokeWidth: 14.9247
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.823 412.731C647.135 369.564 571.12 375.58 528.038 426.169C484.956 476.758 491.123 552.761 541.812 595.927C592.501 639.094 668.516 633.078 711.597 582.489C754.679 531.9 748.512 455.897 697.823 412.731Z",
    stroke: "#C4C4C4",
    strokeWidth: 6.88832
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.528 449.48C636.175 423.632 590.657 427.234 564.86 457.527C539.063 487.819 542.755 533.33 573.107 559.178C603.46 585.026 648.978 581.424 674.775 551.131C700.572 520.839 696.88 475.328 666.528 449.48Z",
    stroke: "#C4C4C4",
    strokeWidth: 14.9247
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.695 469.306C629.877 453.28 601.656 455.514 585.661 474.295C569.667 493.077 571.956 521.293 590.775 537.319C609.594 553.345 637.815 551.112 653.809 532.33C669.803 513.549 667.514 485.332 648.695 469.306Z",
    stroke: "#C4C4C4",
    strokeWidth: 6.88832
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.356 546.43C458.023 550.69 440.113 548.117 425.318 538.546C422.95 537.097 420.658 535.335 418.57 533.556C392.41 511.278 389.336 472.134 411.476 446.136C418.483 437.908 427.204 431.898 436.64 428.389C452.824 422.3 471.103 423.104 486.908 431.265",
    stroke: "#C4C4C4",
    strokeWidth: 14.9247
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.705 457.115C461.746 449.012 443.654 451.774 432.911 464.389C420.766 478.65 422.498 499.997 436.788 512.166C446.02 520.029 458.265 522.129 469.03 518.617",
    stroke: "#C4C4C4",
    strokeWidth: 6.88832
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.517 589.338C478.173 594.724 460.779 595.998 443.886 593.345C425.019 590.337 406.867 582.26 391.259 568.968C388.621 566.721 386.077 564.365 383.735 561.993C345.55 522.661 342.723 460.07 378.97 417.507C385.603 409.718 393.055 403.195 401.012 397.859C420.235 385.084 442.662 379.012 465.15 379.994C482.395 380.675 499.674 385.548 515.155 394.758",
    stroke: "#C4C4C4",
    strokeWidth: 13.7766,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.297 652.461C405.519 664.006 378.019 661.783 358.014 644.747C346.033 634.544 338.872 620.686 336.777 606.222C335.777 598.935 335.996 591.552 337.452 584.275C339.634 574.588 343.991 565.241 350.811 557.233C352.212 555.587 353.817 553.926 355.328 552.374",
    stroke: "#C4C4C4",
    strokeWidth: 5.74026
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.082 695.52C426.064 728.059 363.898 727.353 320.262 690.191C287.946 662.672 273.678 621.754 278.897 582.669C272.104 578.399 265.575 573.596 259.2 568.167C185.447 505.358 176.473 394.761 239.158 321.153C301.75 247.655 412.051 238.822 485.771 301.224",
    stroke: "#C4C4C4",
    strokeWidth: 5.74026
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.629 553.859C348.047 554.689 319.156 545.415 295.634 525.384C245.513 482.7 239.426 407.681 282.025 357.659C322.476 310.159 392.242 302.386 442.023 338.345",
    stroke: "#C4C4C4",
    strokeWidth: 5.74026
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.382 519.395C343.649 516.878 329.321 510.544 317.121 500.153C280.958 469.357 276.571 415.279 307.306 379.188C335.986 345.51 385.231 339.567 421.086 364.044",
    stroke: "#C4C4C4",
    strokeWidth: 5.74026
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.946 476.062C350.011 474.225 346.246 471.965 342.729 468.97C323.274 452.402 320.915 423.329 337.45 403.913C353.612 384.935 381.749 382.401 401.199 397.639L401.105 397.749C409.87 379.663 421.064 362.511 434.61 346.605C521.584 244.475 674.899 232.34 777.23 319.487C879.562 406.633 892 559.924 805.026 662.053C718.051 764.183 564.736 776.318 462.405 689.171C421.956 654.725 395.498 609.861 383.735 561.993",
    stroke: "#C4C4C4",
    strokeWidth: 14.9247
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.708 314.419C403.094 263.368 309.362 272.117 255.646 335.194C200.715 399.696 208.583 496.672 273.213 551.712C276.731 554.707 280.341 557.593 284.029 560.166C290.541 564.765 297.428 568.926 304.468 572.461C302.402 579.786 301.369 587.234 301.056 594.727C299.909 623.463 311.577 652.515 335.319 672.733C369.173 701.564 416.995 703.303 452.243 679.95",
    stroke: "#C4C4C4",
    strokeWidth: 17.2208
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollsBg);
export default __webpack_public_path__ + "static/media/polls-bg.3efb55e0c47a6b3cfd783a7f6a91ea9bfe01f368260dc1ce6831ebbcbbc1e31a.svg";
export { ForwardRef as ReactComponent };